import { Exclude, Type } from "class-transformer";

export class History {
    public version = 2;

    @Type(() => Proband)
    public probanden: Array<Proband> = [];

    @Exclude()
    public getProband(probandid: number): Proband {
        this.probanden.forEach(p => {
           if (p.probandid == probandid)  {
               return p;
           }
        });
        return null;
    }

    @Exclude()
    public newProband(): Proband {
        const proband = new Proband();
        proband.probandid = 1;

        this.probanden.forEach(p => {
            if (proband.probandid <= p.probandid) {
                proband.probandid = p.probandid + 1;
            }
        });

        this.probanden.push(proband);

        return proband;
    }

    @Exclude()
    public clear() {
        this.probanden = [];
    }
}

export class Proband {
    public probandid: number;

    @Type(() => Session)
    public sessions: Array<Session> = [];

    @Exclude()
    public newSession(): Session {
        const session = new Session();

        session.sessionid = 1;
        session.startzeit = new Date();

        this.sessions.forEach(s => {
            if (session.sessionid <= s.sessionid) {
                session.sessionid = s.sessionid + 1;
            }
        });

        this.sessions.push(session);
        return session;
    }
}

export class Session {
    public sessionid: number;
    @Type(() => Date)
    public startzeit: Date;

    @Type(() => Run)
    public runs: Array<Run> = [];

    @Exclude()
    public newRun(): Run {
        const run = new Run();
        this.runs.push(run);
        return run;
    }
}

export class Run {
    @Type(() => Date)
    public startzeit: Date;
    public anschlagrate: number = 0;
    public anschlaegeVorgabe: number = 0;
    @Type(() => Anschlag)
    public anschlaege: Array<Anschlag> = [];

    @Exclude()
    public addAnschlag(t0: number, tlast: number, tnow: number, circle: number): void {
        const anschlag = new Anschlag();
        anschlag.delayFrom0 = tnow - t0;
        anschlag.delayFromLast = tnow - tlast;
        anschlag.circle = circle;
        this.anschlaege.push(anschlag);
    }
}

export class Anschlag {
    public delayFrom0: number;
    public delayFromLast: number;
    public circle: number;
}



// WEBPACK FOOTER //
// ./src/data/data.ts